import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { createHandle } from './actions';
import { useNavigate } from 'react-router-dom';
import HandleEditForm from './HandleEditForm';
import Paper from '@mui/material/Paper';
import { Typography, Box } from '@mui/material';
import { mainPageRootStyle } from '../styles';
import Breadcrumb from '../components/Breadcrumb';

const HandleAddPage = () => {
    const [handle, setHandle] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    React.useEffect(() => {
        document.title = 'Add Handle - Sky Toolbox';
    }, []);

    const handleHandleChange = useCallback((a) => {
        setHandle(a);
    }, []);
    const handleSubmit = useCallback((e) => {
        e.preventDefault();
        dispatch(createHandle(handle, navigate));
    }, [handle, dispatch, navigate]);
    return (
        <Paper style={mainPageRootStyle} sx={{ p: 3 }}>
            <Breadcrumb items={[
                { label: 'Handles', path: '/handles' },
                { label: 'Add Handle' }
            ]} />
            
            {/* Page Header */}
            <Box 
                sx={{ 
                    background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                    borderRadius: 3,
                    p: 3,
                    mb: 4,
                    color: 'white',
                }}
            >
                <Typography variant="h4" component="h1" fontWeight="bold" sx={{ mb: 1 }}>
                    ➕ Add Handle
                </Typography>
                <Typography variant="body1" sx={{ opacity: 0.9 }}>
                    Connect a new BlueSky account
                </Typography>
            </Box>
            
            <HandleEditForm
                handleSubmit={handleSubmit}
                handle={handle}
                handleHandleChange={handleHandleChange}
            />
        </Paper>
    );
};
export default HandleAddPage;